import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const data = await login(form.username, form.password);
      if (data.mustChangePassword) navigate('/change-password');
      else navigate('/dashboard');
    } catch (err) {
      // Read the actual error message from the API response body,
      // not axios's generic "Request failed with status code X" message.
      const apiMsg = err?.response?.data?.error;
      setError(apiMsg || err.message || 'Login failed');
    }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(135deg,#0f2544 0%,#1a3a6b 50%,#0d9488 100%)', padding:16 }}>
      <div style={{ width:'100%', maxWidth:380 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ display:'inline-block', background:'rgba(255,255,255,.1)', color:'#fff', fontSize:10, fontWeight:700, letterSpacing:3, padding:'5px 14px', borderRadius:20, marginBottom:12 }}>TIEP SYSTEM</div>
          <h1 style={{ color:'#fff', fontSize:26, fontWeight:700 }}>Guarantee Tracker</h1>
          <p style={{ color:'rgba(255,255,255,.6)', fontSize:13, marginTop:4 }}>Import / Export Management Portal</p>
        </div>

        <div style={{ background:'#fff', borderRadius:18, padding:'32px 28px', boxShadow:'0 20px 60px rgba(0,0,0,.25)' }}>
          <h2 style={{ fontSize:17, fontWeight:700, marginBottom:22, color:'var(--navy)' }}>Sign in to your account</h2>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div>
              <label className="lbl">Username</label>
              <input className="input" value={form.username} onChange={set('username')} placeholder="Enter username" required autoComplete="username" />
            </div>
            <div>
              <label className="lbl">Password</label>
              <div style={{ position:'relative' }}>
                <input className="input" type={showPw ? 'text' : 'password'} value={form.password} onChange={set('password')} placeholder="Enter password" required autoComplete="current-password" style={{ paddingRight:40 }} />
                <button type="button" onClick={() => setShowPw(!showPw)}
                  style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text2)', fontSize:16 }}>
                  {showPw ? '🙈' : '👁'}
                </button>
              </div>
            </div>
            {error && <div style={{ background:'#fef2f2', border:'1px solid #fca5a5', color:'#b91c1c', padding:'10px 14px', borderRadius:8, fontSize:13 }}>{error}</div>}
            <button type="submit" className="btn btn-navy" disabled={loading} style={{ width:'100%', justifyContent:'center', padding:'12px' }}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
            <Link to="/forgot-password" style={{ textAlign:'center', color:'var(--teal)', fontSize:13, fontWeight:600, textDecoration:'none' }}>
              Forgot password?
            </Link>
          </form>
          <p style={{ textAlign:'center', fontSize:11, color:'var(--text2)', marginTop:20 }}>TIEP Guarantee Management System © {new Date().getFullYear()}</p>
        </div>
      </div>
    </div>
  );
}
